<template>
  <div class="article-share">
    <h5 class="eyebrow">Share this Article</h5>
    <ul class="article-share__social-links">
      <li key="share">
        <button aria-label="copy link to this article" @click="copyURL">
          <img
            alt="link icon"
            src="/img/ui/icon-share.svg"
            width="24"
            height="24"
          />
        </button>
      </li>
      <li v-for="link in socialLinks" :key="link.name">
        <NuxtLink
          :id="`link-${link.name}-${articlename
            .replace(/\s+/g, '-')
            .toLowerCase()}`"
          :to="link.url"
          rel="nofollow noopener"
          target="_blank"
          :aria-label="`Share this article on ${capitalizeFirstLetter(
            link.name
          )}`"
        >
          <img
            :alt="`${capitalizeFirstLetter(link.name)} icon`"
            :src="`/img/ui/icon-${link.name}.svg`"
            width="24"
            height="24"
          />
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
// Props
const props = defineProps<{
  articlename: string;
  url: string;
}>();

const capitalizeFirstLetter = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1);

const copyURL = () => navigator.clipboard.writeText(window.location.href);

/* Domain isn't dynamic, since it needs to be available during generate of the site. So to change the domain used in the social links, update SITE_URL that's defined in nuxt.config.ts. */
const socialLinks = [
  {
    name: 'facebook',
    url: `http://www.facebook.com/share.php?u=${props.url}`,
  },
  {
    name: 'linkedin',
    url: `https://www.linkedin.com/sharing/share-offsite/?url=${props.url}`,
  },
  {
    name: 'twitter',
    url: `https://twitter.com/intent/tweet?url=${props.url}&hashtags=shiftkey`,
  },
];
</script>

<style lang="scss">
.article-share {
  &__social-links {
    display: flex;
    gap: 32px;
    margin-block-start: 24px;
  }
}
</style>
